import React from "react";
import { ImHtmlFive } from 'react-icons/im';
import { BiLogoCss3 } from 'react-icons/bi';
import { TbBrandJavascript } from 'react-icons/tb';
import { BiLogoReact } from 'react-icons/bi';
import { GrNode } from 'react-icons/gr';
import { SiMongodb } from 'react-icons/si';
import { SiMysql } from 'react-icons/si';
import { BsGit } from 'react-icons/bs';
import { SiTensorflow } from 'react-icons/si';
import { SiPytorch } from 'react-icons/si';
import { SiScikitlearn } from 'react-icons/si';
import { SiNumpy } from 'react-icons/si';
import { SiPandas } from 'react-icons/si';
import { IoEyeSharp } from 'react-icons/io5';
import { SiKeras } from 'react-icons/si';
import { SiDeepin } from 'react-icons/si';

function Skills() {
    return (
        <section id="skills">
            <h5>What skills I have</h5>
            <h2>My Skills</h2>

            <div className="experience_container">
                <div className="experience_card">
                    <h3>Full-Stack Development</h3>
                    <div className="experience_content">
                        {renderSkill(ImHtmlFive, "HTML", "Experienced")}
                        {renderSkill(BiLogoCss3, "CSS", "Experienced")}
                        {renderSkill(TbBrandJavascript, "JavaScript", "Experienced")}
                        {renderSkill(BiLogoReact, "React", "Experienced")}
                        {renderSkill(GrNode, "Node", "Experienced")}
                        {renderSkill(SiMongodb, "MongoDB", "Experienced")}
                        {renderSkill(SiMysql, "MySQL", "Experienced")}
                        {renderSkill(BsGit, "VCS", "Experienced")}
                    </div>
                </div>

                <div className="experience_card">
                    <h3>AI/ML</h3>
                    <div className="experience_content">
                        {renderSkill(SiTensorflow, "Tensorflow", "Experienced")}
                        {renderSkill(SiPytorch, "PyTorch", "Beginner")}
                        {renderSkill(SiScikitlearn, "Scikit", "Experienced")}
                        {renderSkill(SiNumpy, "Numpy", "Experienced")}
                        {renderSkill(SiPandas, "Pandas", "Experienced")}
                        {renderSkill(IoEyeSharp, "CV", "Intermediate")}
                        {renderSkill(SiKeras, "Keras", "Experienced")}
                        {renderSkill(SiDeepin, "DL", "Intermediate")}
                    </div>
                </div>
            </div>
        </section>
    );
}

const renderSkill = (Icon, name, level) => (
    <article className="experience_details">
        <Icon className="experience_details-icon" />
        <div>
            <h4>{name}</h4>
            <small className="text-light">{level}</small>
        </div>
    </article>
);

export default Skills;
